import { apiInstanceFactory } from '@/core/api/api.factory';
import { ApiBase } from '@/core/api/api.base';
import { CreateChatRequest, GroupChatMessageViewObject, GroupChatMessagesViewModel, GroupChatViewModel, GroupChatViewObject, SendChatMessageRequest } from '@/api';

const api = apiInstanceFactory();

interface ChatRequestOptions {
    suppressErrors?: boolean;
    hideLoadingBar?: boolean;
}

class CommunicationService extends ApiBase {
    public async sendChatMessage(request: SendChatMessageRequest): Promise<GroupChatMessageViewObject | undefined> {
        return this.callEndpointWithErrorHandling(() => api.api.communicationSendChatMessageCreate(request));
    }

    public async createChat(request: CreateChatRequest): Promise<GroupChatViewObject> {
        const result = await this.callEndpointWithErrorHandling(() => api.api.communicationCreateChatCreate(request));
        return result!; // This is never null
    }

    public async createGuestChat(): Promise<GroupChatViewObject | undefined> {
        return this.callEndpointWithErrorHandling(() => api.api.communicationCreateGuestChatCreate());
    }

    public async deleteChat(chatId: string): Promise<GroupChatViewObject | undefined> {
        return this.callEndpointWithErrorHandling(() => api.api.communicationDeleteChatCreate({
            chatId: chatId,
        }));
    }

    public async renameChat(chatId: string, title: string | null | undefined): Promise<GroupChatViewObject | undefined> {
        return this.callEndpointWithErrorHandling(() => api.api.communicationRenameChatCreate({
            chatId: chatId,
            title: title,
        }));
    }
    
    public async markChatAsRead(chatId: string): Promise<GroupChatViewObject | undefined> {
        return this.callEndpointWithErrorHandling(() => api.api.communicationMarkChatAsReadByUserCreate({
            chatId: chatId,
        }));
    }

    public async getChat(chatId: string): Promise<GroupChatViewObject | undefined> {
        return this.callEndpointWithErrorHandling(() => api.api.communicationGetChatList({
            chatId: chatId,
        }));
    }

    public async getChats(): Promise<GroupChatViewModel | undefined> {
        return this.callEndpointWithErrorHandling(() => api.api.communicationGetChatsList());
    }

    public async getSupportChats(): Promise<GroupChatViewModel | undefined> {
        return this.callEndpointWithErrorHandling(() => api.api.communicationGetSupportChatsList());
    }

    public async getMessagesForChat(chatId: string, skip: number, take: number, options?: ChatRequestOptions): Promise<GroupChatMessagesViewModel | undefined> {
        return this.callEndpointWithErrorHandling(() => api.api.communicationGetMessagesForChatList({
            chatId, skip, take,
        }), {
            suppressErrors: options?.suppressErrors,
            hideLoadingBar: options?.hideLoadingBar,
        });
    }
}

export default new CommunicationService();
